import {SET_DRAG_DROP} from "../Actions/Types/dragDropActionTypes";

const initialState = {
    result: {},
};

export const dragDropReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DRAG_DROP:
            return {
                ...state,
                result: action.result,
            };
        default:
            return state;
    }
};


